<template lang="pug">
.social-feed__card-container
	.social-feed__card(v-for="post in posts" :key="post.id")
		.social-feed__message-container
			.social-feed__message(v-html="post.message")
			.social-feed__interactions
				.social-feed__interaction
					i(:class="interactionClass(post)")
					span {{ post.like_count }}
				.social-feed__interaction
					i.blue-icon-comment
					span {{ post.comment_count }}
		img.social-feed__img(v-if="post.image && post.image.length > 0 && imageExists(post.image)" :src="post.image")
		.social-feed__footer
			a.social-feed__profile-img(:href="post.poster_url" target="_blank")
				img(:src="post.poster_image")
			.social-feed__footer-content
				p.social-feed__profile-name 
					a(:href="post.poster_url" target="_blank") {{ post.poster_name }}
				p.social-feed__posted-time {{ daysSincePosted(post.external_created_at) }} days ago
			a.social-feed__icon(:href="post.full_url" target="_blank")
				i(:class="iconClass(post)")
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: 'Cards',
	data() {
		return {
			
		}
	},
	computed: {
		...mapGetters(["socialData"]),
		posts() {
			return [this.socialData.posts.items[0], this.socialData.posts.items[1]];
		},
	},
	methods: {
		daysSincePosted(timeString) {
			let dateOfPost = new Date(timeString);
			let today = new Date();
			let diffInTime = today.getTime() - dateOfPost.getTime();
			let diffInDays = diffInTime / (1000*60*60*24);
			return Math.ceil(diffInDays);
		},
		iconClass(post) {
			return ["blue-icon-" + post.source.source.toLowerCase()];
		},
		imageExists(imageUrl){
			if (imageUrl && imageUrl.length > 0) {
				var http = new XMLHttpRequest();
				http.open('HEAD', imageUrl, false);
				if (http.status == 200) return false;
				http.send();
				return !http.status.toString().startsWith("4");
			}
		},
		interactionClass(post) {
			if (post.source.source.toLowerCase().includes("facebook") || post.source.source.toLowerCase().includes("youtube")) {
				return "blue-icon-like";
			} else {
				return "blue-icon-heart";
			}
		}
	},
	mounted() {
		
	}
}
</script>

<style lang="scss">
.social-feed {
	&__card-container {
			margin-top: 1rem;
			display: flex;
			column-gap: 1rem;
			align-items: baseline;
			@include mqdn(md) {
				flex-direction: column;
				column-gap: 0;
				row-gap: 1.25rem;
			}
	}
	&__card {
		background: $white;
		flex: 1 1 calc(50% - 0.5rem);
		max-width: calc(50% - 0.5rem);
		@include mqdn(md) {
			flex: 1 1 100%;
			max-width: 100%;
		}
	}
	&__message-container {
		padding: 1rem;
		border-bottom: solid 2px $lightGray;
	}
	&__message {
		line-height: 1.75;
		color: $darkGray;
		p:last-child {
			margin-bottom: 0;
		}
		a {
			word-break: break-word;
		}
	}
	&__interactions {
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.875rem;
	}
	&__interaction {
		display: flex;
		align-items: center;
		color: $darkGray;
		&:not(:last-child) {
			margin-right: 2.5rem;
		}
		i {
			color: darken($lightGray, 10%);
			font-size: 1.125rem;
			margin-right: 0.375rem;
		}
	}
	img.social-feed__img {
		width: 100%;
		max-width: 100%;
	}
	&__footer {
		display: flex;
		padding: 1rem;
		align-items: center;
	}
	&__profile-img {
		width: 60px;
		min-width: 60px;
		height: 60px;
		border-radius: 50%;
		border: solid 2px $lightGray;
		overflow: hidden;
		margin-right: 1rem;
		img {
			height: 100%;
			width: 100%;
			object-fit: cover;
		}
	}
	&__profile-name {
		font-weight: 700;
		margin-bottom: 0.375rem;
		a {
			color: $darkGray;
		}
	}
	&__posted-time {
		font-size: 0.875rem;
		margin-bottom: 0;
		color: $darkGray;
	}
	&__icon {
		font-size: 1.25rem;
		margin-left: auto;
		align-self: flex-start;
	}
}
</style>
